import * as React from 'react';
import * as ReactModal from 'react-modal';
import './styles.scss';
import Icons from '../../icons';



export default class DialogueBox extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            showModel:false,
            prevIsOpen:props.isOpen
        }

        this.onClose = this.onClose.bind(this);
    }

    static getDerivedStateFromProps(props, state){
        if(props.isOpen!==state.prevIsOpen){
            return {
                showModel:props.isOpen,
                prevIsOpen:props.isOpen
            };
        }
        return null;
    }

    render(){
        if(!this.state.showModel)
            return null;

        return(
            <ReactModal
                ariaHideApp={false}
                style={ this.props.componentStyles }
                isOpen={ this.state.showModel }
                className={this.props.contentClassName || `dialogue-box-popup ${this.props.modalClassNames}` }
                overlayClassName={this.props.overlayClassName || "dialogue-box-popup-overlay"}
                onRequestClose={this.onClose}
                shouldCloseOnOverlayClick={this.props.shouldCloseOnOverlayClick || false}>
                    {
                        this.props.title &&
                        (
                            <div className="popup-header">
                                <span className="popup-title ">{this.props.title.toUpperCase()}</span>
                                <span className="close-popup" onClick={this.onClose}><Icons className="close" name="close"  /></span>
                            </div>
                        )
                    }
                    {
                        this.props.contentClassName?(
                            this.props.children
                        ):(
                            <div className="popup-content">
                                {this.props.children}
                            </div>
                        )
                    }
            </ReactModal>
        );
    }

    onClose(){
        this.setState({
            showModel:false
        });

        if(this.props.onRequestClose)
            this.props.onRequestClose();
    }
}